import React, { ReactNode } from 'react';
import './bits.scss';

interface TileProps {
  title?: string;          // Optional title
  subtitle?: string;       // Optional subtitle
  children?: ReactNode;    // Children prop for content inside the tile
  disabled?: boolean;      // Optional disabled prop to disable tile
}

const Tile: React.FC<TileProps> = ({ title, subtitle, children, disabled = false }) => {
  return (
    <div
      className={`sgpsTile ${disabled ? 'sgpsTile--disabled' : ''}`}
    >
      {title && (
        <div className="sgpsTile__content">
          <div className="sgpsTile__title">{title}</div>
          {subtitle && <div className="sgpsTile__notes">{subtitle}</div>}
        </div>
      )}
      {children}
    </div>
  );
};

export default Tile;